module.exports = __webpack_public_path__ + "img/file-image.2dafdeac.svg";